<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Large file sizes - compacting an access file</h3>
    <div>
      <div>
        <div>
          <div>
            <p class="NOTE">
              Even without a lot of records in them access files can get very large. When data is added, updated and deleted, it creates spaces in the
              file - making the file larger. Fortunately, access provides a utility to <em>compact</em> the file and make it as small as possible.
              Simply open the file in access and choose <em>Compact and Repair Database</em>.
            </p>
            <br />
            The process is usually a few seconds. Check the
            <a class="text">file size</a>. I could be dramatically smaller. This will greatly assist the time it takes to <em>upload</em> the file to
            incenti-web.
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'AccessCompact',
};
</script>
<style scoped>
h3 {
  text-align: center;
}
p {
  width: inherit;
  text-align: 'center';
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
